const designerList = {
  title: () => 'Shop italist | Best price for more than 1000 designer brands',
  description: () =>
    'Shop at italist: the largest selection of fashion luxury goods from Italy’s finest stores. EXPRESS international shipping!'
};

export default designerList;
